/**
 * Binds the note-suggestions host from the four mounts that render the surface.
 * Not imported from `_app`: that would pull the note-sync delegate and the
 * document diff into the first-load graph of every page.
 */
import {
  ADAPTIVE_LEARNING_OPTIN_POPOVER_MODAL_ID,
  adaptiveLearningPreviewHoldAtom,
} from '@/atoms/adaptiveLearningPopoverAtoms';
import { currentQueuedModalAtom } from '@/atoms/modalQueueAtoms';
import { useMutateSyncNoteToServer } from '@/hooks/mutation/useMutateUpdateNoteBySessionId';
import {
  computeDocumentDiffChanges,
  isEditorLive,
  whenEditorLive,
} from '@heidi/editor/core';
import { configureNoteSuggestionsUi } from '@heidi/session';
import { useAtomValue } from 'jotai';

/** Offer preview stays up while its card is the current modal, or during graduation. */
export function useIsOptInPreviewAllowed(): boolean {
  const currentQueuedModal = useAtomValue(currentQueuedModalAtom);
  const previewHold = useAtomValue(adaptiveLearningPreviewHoldAtom);
  return (
    currentQueuedModal?.id === ADAPTIVE_LEARNING_OPTIN_POPOVER_MODAL_ID || previewHold
  );
}

configureNoteSuggestionsUi({
  useSyncNoteToServer: useMutateSyncNoteToServer,
  useIsOptInPreviewAllowed,
  isEditorLive,
  whenEditorLive,
  computeDocumentDiffChanges,
});
